/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = AG (AG)
 * 
 * 805290009 = AdOR (AdÖR)
 * 
 * 805290001 = BgA (BgA)
 * 
 * 805290002 = eV (e.V.)
 * 
 * 805290003 = gAG (gAG)
 * 
 * 805290004 = gGmbH (gGmbH)
 * 
 * 805290005 = GmbH (GmbH)
 * 
 * 805290006 = KdoR (KdöR)
 * 
 * 805290007 = Stiftung (Stiftung)
 * 
 * 805290008 = Sonstige (Sonstige)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceRechtsform {
 AG = 805290000,
 AdOR = 805290009,
 BgA = 805290001,
 eV = 805290002,
 gAG = 805290003,
 gGmbH = 805290004,
 GmbH = 805290005,
 KdoR = 805290006,
 Stiftung = 805290007,
 Sonstige = 805290008
}

marker([
    "Enum.GlobalEnumsAceRechtsform.AG",
    "Enum.GlobalEnumsAceRechtsform.AdOR",
    "Enum.GlobalEnumsAceRechtsform.BgA",
    "Enum.GlobalEnumsAceRechtsform.eV",
    "Enum.GlobalEnumsAceRechtsform.gAG",
    "Enum.GlobalEnumsAceRechtsform.gGmbH",
    "Enum.GlobalEnumsAceRechtsform.GmbH",
    "Enum.GlobalEnumsAceRechtsform.KdoR",
    "Enum.GlobalEnumsAceRechtsform.Stiftung",
    "Enum.GlobalEnumsAceRechtsform.Sonstige"
]);

export namespace GlobalEnumsAceRechtsform
{
    class DataSets
    {
        static GlobalEnumsAceRechtsformDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("AG", 805290000, "AG"),
            new EnumValue("AdOR", 805290009, "AdÖR"),
            new EnumValue("BgA", 805290001, "BgA"),
            new EnumValue("eV", 805290002, "e.V."),
            new EnumValue("gAG", 805290003, "gAG"),
            new EnumValue("gGmbH", 805290004, "gGmbH"),
            new EnumValue("GmbH", 805290005, "GmbH"),
            new EnumValue("KdoR", 805290006, "KdöR"),
            new EnumValue("Stiftung", 805290007, "Stiftung"),
            new EnumValue("Sonstige", 805290008, "Sonstige"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceRechtsformDataSet;
    }
}
